const generateProfileShareLink = (slug: string) => {
  return `${process.env.REACT_APP_ENVIRONMENT_URL}/share/profile/${slug}`;
};

export default generateProfileShareLink;
